import { CHECK_ELASTIC_LEADS, CUSTOMER_SOURCE_WALK_IN_CODE, SEARCH_ELASTIC } from "app/appConfig";
import { LIST_GENDER, PAGESIZE_ALL } from "app/common/LocalConst";
import {
  convertDataLead,
  getSourceCustomerCompanionCode,
  normalizeDataForServer,
} from "app/common/LocalFunction";
import { CheckIn } from "app/common/Model/CheckIn";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingElasticLeads, pagingElasticPatient } from "app/services/ElasticPatient";
import { pagingLead } from "app/services/LeadCRMService";
import {
  cancleCheckIn,
  checkCompanions,
  checkIn,
  CheckOut,
  checkPatient,
  getCheckinById,
  pagingCheckIn,
  pagingReceptionEncounter,
} from "app/services/ReceptionService";
import { searchCheckInHistory } from "app/services/ESCheckInHistoryService";
import { pagingVisitType } from "app/services/VisitTypeService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
const DEFAULT_VALUE_CHECKOUT = {
  departmentids: null,
  visitDate: new Date(),
};
const DEFAULT_VALUE = {
  patient: {
    gender: LIST_GENDER[1].value,
  },
  issueDate: new Date(),
};
export default class ListCheckInStore {
  searchCheckIn = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    hasBill: null,
    hasRevenue: null,
    hasDebt: null,
    hasAppointment: null,
    sourceId: null,
    sourceDetailId: null,
  };

  initDataCheckIn = {
    ...DEFAULT_VALUE,
  };

  initDataCheckOut = {
    ...DEFAULT_VALUE_CHECKOUT,
  };

  searchDuplicatePatient = {
    ...new SearchObject(),
    phoneNumber: "",
    searchArchive: false,
  };

  openPopupSearchLead = false;
  pageCheckIn = new PageResponse();
  openFormCreateOrEdit = false;
  initialCheckIn = null;
  openConfirmDelete = false;
  openCheckin = false;
  openPopupDuplicatePatient = false;
  duplicatePatients = new PageResponse();
  openConfirmCheckIns = null;
  openConfirmHasAppointments = null;
  openConfirmError = null; //check khi chinh sua loi
  openConfirmDeleteError = null; //check khi xoa loi
  duplicatePatientSelected = null;
  openCheckInDependentPersonPopup = false;
  openPopupSearchDependentPersonLead = false;
  openConfirmHasAppointment = null;
  initCheckInDependentPerson = null;
  openPopupCheckDuplicateDependentPerson = false;
  listCompanionsSearchDuplicateIndex = new Set([]);
  customerSourceForCompanionDefault = null;
  openCheckout = false;
  openCheckInHistoryElasticPopup = false;
  searchCheckInHistoryElastic = new SearchObject();
  pageCheckInHistoryElastic = new PageResponse();
  constructor() {
    makeAutoObservable(this);
  }
  handleOpenFormCreateOrEdit = async (checkIn) => {
    if (checkIn?.id) {
      getCheckinById(checkIn?.id).then(({ data }) => {
        console.log("data", data);
        this.initDataCheckIn = data;
        this.openCheckin = true;
      });
    } else {
      const visitType = await this.getVisitType();
      this.initDataCheckIn = {
        ...DEFAULT_VALUE,
        issueDate: new Date(),
        visitType,
      };
      this.openCheckin = true;
    }
  };

  searchLead = { ...new SearchObject(), pageSize: 10 };
  leadPatient = null;
  openSearchLead = false;
  handleSearchDuplicateInPersonal = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;

    const newObj = {
      ...this.searchLead,
      pageIndex: pageIndex || this.searchLead?.pageIndex,
      pageSize: pageSize || this.searchLead?.pageSize,
      ...ortherData,
    };

    try {
      const { data } = await pagingLead({ ...newObj });
      if (data?.content?.length > 0) {
        this.searchLead = newObj;
        this.leadPatient = data;
        this.openSearchLead = true;
      }
      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleSearchLead = async () => {
    try {
      let { data } = await pagingLead({ ...this.searchLead });
      this.leadPatient = data;
      this.openSearchLead = true;
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra khi tìm lead vui lòng thử lại!");
    }
  };

  handleCloseSearchListPopup = () => {
    this.openSearchLead = false;
  };

  handleSelectLeadSelectLeadPersonal = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.openSearchLead = false;

    this.initDataCheckIn = {
      patient: {
        ...convertPatient,
        phoneNumber: this.searchLead?.phoneNumber,
      },
      leadId: patient?.id,
      lead: patient,
      marketingType: patient?.marketingType,
      phoneNumber: this.searchLead?.phoneNumber,
      visitType: this.searchLead?.dataValue?.checkTypeVisit,
      receptionist: this.searchLead?.dataValue?.receptionist,
      issueDate: this.searchLead?.dataValue?.issueDate,
      department: this.searchLead?.dataValue?.department,
    };
  };

  setOpenCheckout = () => {
    this.openCheckout = true;
  };

  handleClosePopupCheckout = () => {
    this.openCheckout = false;
  };

  handleOpenCheckout = (obj, { setSubmitting }) => {
    return CheckOut(obj)
      .then(({ data }) => {
        this.openCheckout = false;
        toast.success(`Đã check out ${data} bản ghi`);
        pagingCheckIn();
        return data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Check out thông tin có lỗi");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  getVisitType = async () => {
    return await pagingVisitType({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
      keyword: "offline_checkin",
    })
      .then(({ data }) => {
        if (data?.content?.length > 0) {
          return data?.content?.[0];
        }
        return null;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu loại check in có lỗi");
      });
  };

  setOpenConfirmCheckIns = (state) => {
    this.openConfirmCheckIns = state;
  };

  pagingCheckIn = async () => {
    let {
      departmentId,
      practitionerId,
      sourceId,
      sourceDetailId,
      ...ortherData
    } = this.searchCheckIn;
    if (departmentId && departmentId?.id) {
      ortherData.departmentId = departmentId?.id;
    }
    if (practitionerId && practitionerId?.id) {
      ortherData.practitionerId = practitionerId?.id;
    }
    if (sourceId && sourceId?.id) {
      ortherData.sourceId = sourceId?.id;
    }
    if (sourceDetailId && sourceDetailId?.id) {
      ortherData.sourceDetailId = sourceDetailId?.id;
    }
    let api = pagingCheckIn;
    const isPatientGeneral =
      window.location.pathname.includes("patient-general");

    if (isPatientGeneral) {
      api = pagingReceptionEncounter;
    }
    return await api({ ...ortherData })
      .then(({ data }) => {
        this.pageCheckIn = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu check in khách hàng có lỗi");
      });
  };

  handleChangeFormSearch = (searchCheckIn) => {
    this.searchCheckIn = { ...this.searchCheckIn, ...searchCheckIn };
    this.pagingCheckIn();
  };

  pagingCheckInHistoryElastic = async () => {
    try {
      const searchObj = {
        ...this.searchCheckInHistoryElastic,
        id: null,
        pageIndex: this.searchCheckInHistoryElastic.pageIndex || 1,
        pageSize: this.searchCheckInHistoryElastic.pageSize || 10,
      };
      const { data } = await searchCheckInHistory(searchObj);
      this.pageCheckInHistoryElastic = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu lịch sử check in có lỗi");
    }
  };

  handleOpenCheckInHistoryElastic = (rowData) => {
    this.searchCheckInHistoryElastic = {
      ...new SearchObject(),
      visitId: rowData?.visitId,
      pageIndex: 1,
      pageSize: 10,
    };
    this.pagingCheckInHistoryElastic();
    this.openCheckInHistoryElasticPopup = true;
  };

  handleCloseCheckInHistoryElastic = () => {
    this.openCheckInHistoryElasticPopup = false;
  };

  handleChangeFormSearchCheckInHistoryElastic = (searchObject) => {
    this.searchCheckInHistoryElastic = {
      ...this.searchCheckInHistoryElastic,
      ...searchObject,
    };
    this.pagingCheckInHistoryElastic();
  };

  setOpenConfirmCheckIn = (state) => {
    this.openFormCreateOrEdit = state;
  };

  handleCloseCheckinPopup = () => {
    this.openCheckin = false;
    this.duplicatePatientSelected = null;
    this.duplicatePatients = new PageResponse();
    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      issueDate: new Date(),
    };
  };
  setOpenConfirmHasAppointments = (state) => {
    this.openConfirmHasAppointment = state;
  };
  setOpenConfirmError = (state) => {
    this.openConfirmError = state;
  };

  setOpenConfirmDeleteError = (state) => {
    this.openConfirmDeleteError = state;
  };

  saveOrUpdateCheckin = async (obj, { setSubmitting }) => {
    try {
      let newObj = { ...obj };
      // tìm thấy kh trùng thì set patient
      if (this.duplicatePatientSelected?.id) {
        newObj.patient = {
          ...this.duplicatePatientSelected,
          phoneNumber: obj.patient.phoneNumber,
          displayName: obj.patient.displayName,
          gender: obj.patient.gender,
        };
      }
      // nếu ko có patient thì sẽ là Khách vãng lại
      if (!newObj?.patient?.id) {
        newObj = {
          ...newObj,
          currentPatientSource: {
            ...(newObj.currentPatientSource || {}),
            code: CUSTOMER_SOURCE_WALK_IN_CODE,
          },
        };
      }

      // Thêm currentPatientSource và currentPatientSourceDetail vào visit nếu có visitId
      if (newObj.visitId) {
        newObj.visit = {
          id: newObj.visitId,
          currentPatientSource: newObj.currentPatientSource
            ? { id: newObj.currentPatientSource.id }
            : null,
          currentPatientSourceDetail: newObj.currentPatientSourceDetail
            ? { id: newObj.currentPatientSourceDetail.id }
            : null,
        };
      }

      const { data } = await checkIn(newObj);

      if (data?.responseStatus) {
        toast.success("Check in thông tin thành công!");
        this.pagingCheckIn();
        this.handleCloseCheckinPopup();
      } else if (data?.responseStatus === false && data?.hasAppointment) {
        this.openConfirmHasAppointment = {
          responseDetail: data?.responseDetail,
          appointmentId: data?.appointmentId,
        };
        return data?.responseStatus;
      } else if (data?.responseStatus === false) {
        if (data?.dupPatientByPhones?.length > 0) {
          //TH sau khi submit mà trùng dup phone
          this.duplicatePatients = data?.dupPatientByPhones;
          this.openDupPatientByPhones = {
            dataValue: newObj,
            responseDetail: data?.responseDetail,
          };
        } else {
          this.openConfirmCheckIns = data?.responseDetail;
        }

        return data?.responseStatus;
      }

      if (newObj?.isCompanions) {
        this.openCheckInDependentPersonPopup = true;
        await this.getCustomerSourceForCompanionDefault(
          data?.currentPatientSource?.platform
        );
        console.log("vvvv", this.customerSourceForCompanionDefault);

        const patient = {
          phoneNumber: data?.patient?.phoneNumber,
          displayName: "",
          gender: LIST_GENDER[1].value,
        };

        this.initCheckInDependentPerson = {
          ...data,
          issueDate: new Date(),
          companions: [
            {
              patient,
              issueDate: new Date(),
              currentPatientSource: this.customerSourceForCompanionDefault,
            },
          ],
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Check in thông tin có lỗi");
    } finally {
      setSubmitting(false);
    }
  };

  getCustomerSourceForCompanionDefault = async (platform) => {
    // when create patient ,firstPatientSource or currentPatientSource not provided
    //set default source have code NKV_VL in system config
    let companyCode = getSourceCustomerCompanionCode();
    let { data } = await pagingCustomerSource({
      listCustomerSourceCode: companyCode,
      pageSize: PAGESIZE_ALL,
      pageIndex: 1,
    });
    console.log("platform", platform);
    if (platform) {
      let currentPatientSource = data?.content?.find(
        (el) => el?.platform === platform
      );
      this.customerSourceForCompanionDefault = currentPatientSource;
    }
  };

  saveCheckCompanions = async (obj, index) => {
    try {
      const { data } = await checkCompanions({
        ...obj,
        currentIndex: index,
      });
      const currentCompanions = data?.companions?.[index];
      if (data && currentCompanions?.responseStatus) {
        this.initCheckInDependentPerson = {
          ...data,
        };
        this.pagingCheckIn();
        toast.success("Check in thông tin thành công!");
      } else if (
        //  has appointment
        data &&
        currentCompanions?.responseStatus === false &&
        currentCompanions?.hasAppointment
      ) {
        this.openConfirmHasAppointment = {
          responseDetail: currentCompanions?.responseDetail,
          appointmentId: currentCompanions?.appointmentId,
          companionsIndex: data?.currentIndex,
        };
      } else if (data && currentCompanions?.responseStatus === false) {
        this.openConfirmCheckIns = {
          responseDetail: currentCompanions?.responseDetail,
          companionsIndex: data?.currentIndex,
        };
      }
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseCreateOrEditPopup = () => {
    this.openFormCreateOrEdit = false;
    this.duplicatePatients = new PageResponse();
    this.duplicatePatientSelected = null;
  };

  handleCloseCheckInDependentPersonPopup = () => {
    this.openCheckInDependentPersonPopup = false;
    this.duplicatePatientSelected = null;
    this.duplicatePatients = new PageResponse();
    this.listCompanionsSearchDuplicateIndex = new Set();
    this.customerSourceForCompanionDefault = null;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
    this.initialCheckIn = new CheckIn();
  };

  handleDeleteCheckIn = (checkIn) => {
    this.initialCheckIn = { id: checkIn?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDeleteCheckIn = async () => {
    return await cancleCheckIn(this.initialCheckIn?.id)
      .then(({ data }) => {
        if (data?.responseStatus === false) {
          this.openConfirmDeleteError = data;
          // this.openConfirmDelete = false;
          return;
        }
        if (
          this.pageCheckIn?.pageIndex > 1 &&
          this.pageCheckIn?.content?.length === 1
        ) {
          this.pageCheckIn.pageIndex -= 1;
        }
        toast.success("Hủy check in thành công!");
        this.openConfirmDelete = false;
        this.pagingCheckIn();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
      });
  };

  handleCheckPatient = async () => {
    try {
      let data = null;
      let dataApi = null;
      //gọi lead trước

      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
        // toast.error("Đã có lỗi xảy ra khi tìm lead vui lòng thử lại!");
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchLead = true;
        data = dataApi?.data;
      } else {
        // ko có lead thì gọi kh
        try {
          const patientResponse = await pagingElasticPatient({
            ...this.searchDuplicatePatient,
            keyword: this.searchDuplicatePatient?.phoneNumber,
          });

          if (patientResponse?.data?.content?.length > 0) {
            this.duplicatePatients = patientResponse?.data;
            this.openPopupDuplicatePatient = true;
            data = patientResponse?.data;
          } else {
            return [];
          }
        } catch (err) {
          console.error("checkPatient cũng lỗi", err);
          // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
        }
      }
      return data?.content;
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleChangeFormSearchDuplicate = (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };
    const listPatient = this.handleCheckPatient();
    return listPatient;
  };

  handleChangeFormSearchDependentPerson = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentPerson();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  handleChangeFormSearchDuplicateOnlyLead = async (obj) => {
    let { pageIndex, pageSize, ...ortherData } = obj;
    this.searchDuplicatePatient = {
      ...this.searchDuplicatePatient,
      pageIndex: pageIndex || this.searchDuplicatePatient?.pageIndex,
      pageSize: pageSize || this.searchDuplicatePatient?.pageSize,
      ...ortherData,
    };

    const listPatient = await this.handCheckPatientDependentOnlyLead();

    if (listPatient?.length > 0) {
      // nếu tìm thấy duplicate patient
      this.listCompanionsSearchDuplicateIndex.add(obj?.currentIndex);
    }
    return listPatient;
  };

  handCheckPatientDependentPerson = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          } else {
            const patientResponse = await pagingElasticPatient({
              // dùng chung biến search
              ...this.searchDuplicatePatient,
              keyword: this.searchDuplicatePatient?.phoneNumber,
            });
            if (patientResponse?.data?.content?.length > 0) {
              this.duplicatePatients = patientResponse?.data;
              this.openPopupCheckDuplicateDependentPerson = true;
              data = patientResponse?.data;
            } else {
              return [];
            }
          }
        } else {
          const patientResponse = await pagingElasticPatient({
            // dùng chung biến search
            ...this.searchDuplicatePatient,
            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (patientResponse?.data?.content?.length > 0) {
            this.duplicatePatients = patientResponse?.data;
            this.openPopupCheckDuplicateDependentPerson = true;
            data = patientResponse?.data;
          } else {
            return [];
          }
        }
      }

      return data?.content;
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handCheckPatientDependentOnlyLead = async () => {
    try {
      let dataApi = null;
      let data = null;
      try {
        dataApi = await pagingLead({ ...this.searchDuplicatePatient });
      } catch (error) {
        console.error(error);
      }

      if (dataApi?.data?.content?.length > 0) {
        this.duplicatePatients = dataApi?.data;
        this.openPopupSearchDependentPersonLead = true;
        data = dataApi?.data;
      } else {
        if (CHECK_ELASTIC_LEADS) {
          const elasticLeadResponse = await pagingElasticLeads({
            ...this.searchDuplicatePatient,
            searchArchive: false,

            keyword: this.searchDuplicatePatient?.phoneNumber,
          });
          if (elasticLeadResponse?.data?.content?.length > 0) {
            // Chuẩn hóa dữ liệu để xóa các trường date metadata
            const normalizedData = {
              ...elasticLeadResponse?.data,
              content: elasticLeadResponse?.data?.content?.map((item) =>
                normalizeDataForServer(item, true)
              ),
            };
            this.duplicatePatients = normalizedData;
            this.openPopupSearchDependentPersonLead = true;
            data = normalizedData;
          }
        }
      }
      return data?.content || [];
    } catch (error) {
      console.error(error);
      // toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleSelectDuplicatePatient = (patient) => {
    this.duplicatePatientSelected = patient;
    this.openPopupDuplicatePatient = false;
    this.openPopupSearchLead = false;

    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      ...this.searchDuplicatePatient?.dataValue,
      patient: {
        ...patient,
        phoneNumber: this.searchDuplicatePatient?.phoneNumber,
        displayName: patient?.fullName,
        gender: patient?.gender
          ? patient?.gender
          : this.searchDuplicatePatient?.dataValue?.patient?.gender,
      },
      issueDate: new Date(),
    };
  };

  handleSelectDuplicateDependentPerson = (patient) => {
    this.duplicatePatientSelected = patient;
    this.openPopupCheckDuplicateDependentPerson = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: { ...patient, displayName: patient?.fullName },
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleSelectLeadPatient = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.duplicatePatientSelected = { ...convertPatient, isLead: true };
    this.openPopupDuplicatePatient = false;
    this.openPopupSearchLead = false;

    this.initDataCheckIn = {
      ...DEFAULT_VALUE,
      ...this.searchDuplicatePatient?.dataValue,
      patient: {
        ...convertPatient,
        phoneNumber: this.searchDuplicatePatient?.phoneNumber,
      },
      leadId: patient?.id,
      lead: patient,
      issueDate: new Date(),
    };
  };

  handleSelectDependentPersonLeadPatient = (patient) => {
    let convertPatient = convertDataLead(patient);
    this.duplicatePatientSelected = { ...convertPatient, isLead: true };
    this.openPopupSearchDependentPersonLead = false;
    const oldCompanions = this.searchDuplicatePatient?.oldData?.companions;
    const newCompanions = oldCompanions?.map((el, ind) => {
      if (this.searchDuplicatePatient?.currentIndex === ind) {
        return {
          ...el,
          patient: convertPatient,
          leadId: patient?.id,
          lead: patient,
          // isMainPhoneNumber: true,
        };
      } else return el;
    });
    this.initCheckInDependentPerson = {
      ...this.searchDuplicatePatient?.oldData,
      companions: newCompanions,
    };
  };

  handleClosePopupDuplicatePatient = () => {
    this.openPopupDuplicatePatient = false;
  };
  handleClosePopupCheckDuplicateDependentPerson = () => {
    this.openPopupCheckDuplicateDependentPerson = false;
  };
  handleClosePopupSearchLead = () => {
    this.openPopupSearchLead = false;
  };

  handleClosePopupSearchDependentPersonLead = () => {
    this.openPopupSearchDependentPersonLead = false;
  };

  resetStore = () => {
    this.searchCheckIn = {
      ...new SearchObject(),
      fromDate: new Date(),
      toDate: new Date(),
    };
    this.pageCheckIn = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.initialCheckIn = null;
    this.openCheckin = null;
    this.openConfirmHasAppointment = null;
    this.checkIn = null;
    this.duplicatePatientSelected = null;
    this.openConfirmError = null;
    this.openConfirmDeleteError = null;
  };
  resetStoreDetail = () => {
    //hàm này để trong trang chi tiết KH thì để fromdate từ đầu năm
    this.searchCheckIn = {
      ...new SearchObject(),
      fromDate: new Date(new Date().getFullYear(), 0, 1),
      toDate: new Date(),
    };
    this.pageCheckIn = new PageResponse();
    this.openFormCreateOrEdit = false;
    this.initialCheckIn = null;
    this.checkIn = null;
    this.searchLeads = [];
    this.openPopupSearchLead = false;
    this.openConfirmError = null;
    this.openConfirmDeleteError = null;
  };
}
